<div #nodeBox class="cm-material-node" [style.width]="$info().editor.width" [class.cm-selected]="$selected()">
    @let info = $info();
    @let material = $material();
    @let disabled = $disabled();
    <div [style.background]="info.color + 20" [style.color]="info.color" class="cm-name" [class.disabled]="disabled">
        {{ info.label }}
        <div class="cm-icons">
            @if (localStorageService.developmentMode) {
                <i [tp]="DebugMaterialParametersTooltipComponent" tpVariation="light" [tpData]="material" class="far fa-bug"> </i>
            }
            <i [tp]="MaterialSupportTooltipComponent" tpVariation="light" [tpData]="info.support" class="far" [class]="$iconClass()"> </i>
            @if (material.disableable) {
                <cm-toggle [toggle]="!disabled" (toggleChange)="toggleDisabled()"></cm-toggle>
            }
        </div>
    </div>
    <div class="cm-content" [class.disabled]="disabled">
        @for (item of info.items; track item.uniqueId) {
            @if (isVisible(item)) {
                @if (item.definition.output) {
                    <cm-material-output-socket [definition]="item.definition" [material]="material" [nodeId]="$nodeId()"> </cm-material-output-socket>
                }
                @if (item.definition.input) {
                    <cm-material-input-socket [definition]="item.definition" [material]="material" [nodeId]="$nodeId()" [value]="item.scalarValue">
                    </cm-material-input-socket>
                }
                @if (!item.definition.input && item.definition.setting) {
                    <cm-material-setting [definition]="item.definition" [material]="material" [value]="item.scalarValue"> </cm-material-setting>
                }
                @if (item.definition.custom) {
                    <cm-material-custom-item
                        [material]="material"
                        [materialId]="$materialId()"
                        [materialRevisionId]="$materialRevisionId()"
                        [definition]="item.definition"
                    ></cm-material-custom-item>
                }
            }
        }
    </div>
</div>
